import { PageLayout } from '@spotify/confidence-core-react';

import { AuthDebug } from '../AuthDebug';

export const DebugPage = () => {
  return (
    <PageLayout title="Debug">
      <AuthDebug />
    </PageLayout>
  );
};
